import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "input-group search-container" }
const _hoisted_2 = { class: "input-group-append" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search font-size-sm" }, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "me-0 ms-lg-4" }
const _hoisted_6 = { class: "me-auto ms-lg-4" }
const _hoisted_7 = { class: "table table-responsive-md border border-gray" }
const _hoisted_8 = { class: "bg-table-header table-header" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Referral Date ")
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Requested SOC ")
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Patient Information ")
const _hoisted_16 = { key: 4 }
const _hoisted_17 = { key: 5 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Branch ")
const _hoisted_19 = { key: 6 }
const _hoisted_20 = { key: 7 }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Line of Service ")
const _hoisted_22 = { key: 8 }
const _hoisted_23 = { key: 9 }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Referral Type ")
const _hoisted_25 = { key: 10 }
const _hoisted_26 = { key: 11 }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Date of Birth ")
const _hoisted_28 = { key: 12 }
const _hoisted_29 = { key: 13 }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Sex ")
const _hoisted_31 = { key: 14 }
const _hoisted_32 = { key: 15 }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Created By ")
const _hoisted_34 = { key: 16 }
const _hoisted_35 = { key: 17 }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Liaison ")
const _hoisted_37 = { key: 18 }
const _hoisted_38 = { key: 19 }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Tags ")
const _hoisted_40 = { key: 20 }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions", -1 /* HOISTED */)
const _hoisted_42 = {
  key: 0,
  class: "table-empty"
}
const _hoisted_43 = ["colspan"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("h3", null, "No Referrals Found.", -1 /* HOISTED */)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = {
  key: 2,
  class: "table-error"
}
const _hoisted_49 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_BranchDefaultFilter = _resolveComponent("BranchDefaultFilter")!
  const _component_SortableTh = _resolveComponent("SortableTh")!
  const _component_ErrorMessageHandler = _resolveComponent("ErrorMessageHandler")!
  const _component_CentralReferralRow = _resolveComponent("CentralReferralRow")!
  const _component_StaticTableFormater = _resolveComponent("StaticTableFormater")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_ListLayout = _resolveComponent("ListLayout")!

  return (_openBlock(), _createBlock(_component_ListLayout, {
    "form-title": "Referrals",
    "has-list-scroll": false
  }, {
    "list-header": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control border-end-0",
          placeholder: "Search Referrals by Patient Name",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.term) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.term]
        ]),
        _createElementVNode("span", _hoisted_2, [
          _createElementVNode("div", {
            class: "input-group-text bg-transparent p-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.search()))
          }, _hoisted_4)
        ])
      ])
    ]),
    "list-header-drop": _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_MultiSelect, {
          "drop-down-options": _ctx.agencyMultiSelectOptions,
          "selected-options": _ctx.selectedAgencies,
          onUpdateBranches: _ctx.updateBranchesbyAgency,
          "label-text": "Organizations"
        }, null, 8 /* PROPS */, ["drop-down-options", "selected-options", "onUpdateBranches"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_BranchDefaultFilter, {
          "check-all-by-default": true,
          "selected-branches": _ctx.selectedBranches,
          onUpdateBranches: _ctx.updateBranches,
          "selected-agencies-name": _ctx.selectedAgenciesName,
          "is-referral": true
        }, null, 8 /* PROPS */, ["selected-branches", "onUpdateBranches", "selected-agencies-name"])
      ])
    ]),
    "list-header-new": _withCtx(() => [
      (_ctx.excelExportPermission)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-sm btn-primary ms-lg-2",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.downloadChart()))
          }, " Export to Excel "))
        : _createCommentVNode("v-if", true),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-sm btn-primary ms-lg-2",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.newReferral()))
      }, "New")
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Pagination, {
        ref: "referralListPagination",
        pageChanged: _ctx.pageChangedCallback,
        isLoading: _ctx.isLoading,
        entity: "Referrals",
        showPageSizeOptions: true,
        classes: "pagination-footer",
        pageSize: _ctx.pageSize,
        onUpdatePageSizeChanged: _ctx.updatePageSizeChanged
      }, {
        default: _withCtx(() => [
          _createVNode(_component_StaticTableFormater, {
            enabled: true,
            isLoading: !(!_ctx.isLoading && _ctx.hasData),
            backColumnCount: 1,
            frontColumnCount: 4,
            tableColumnSettings: _ctx.getCustomSettings(),
            columnsAltered: _ctx.dynamicTableToggled,
            columns: _ctx.columns,
            "onUpdate:columns": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.columns) = $event))
          }, {
            default: _withCtx(() => [
              _createElementVNode("table", _hoisted_7, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_8, [
                    (_ctx.hasData)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_9, [
                          _createVNode(_component_SortableTh, {
                            "sort-by": _ctx.sortBy,
                            onSortByUpdated: _ctx.sortByUpdated,
                            "sort-order": _ctx.sortOrder,
                            onSortOrderUpdated: _ctx.sortOrderUpdated,
                            "sort-string": "referralDate"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_10
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.hasData)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_11, [
                          _createVNode(_component_SortableTh, {
                            "sort-by": _ctx.sortBy,
                            onSortByUpdated: _ctx.sortByUpdated,
                            "sort-order": _ctx.sortOrder,
                            onSortOrderUpdated: _ctx.sortOrderUpdated,
                            "sort-string": "requestedStartOfCareDate"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                        ]))
                      : (_openBlock(), _createElementBlock("th", _hoisted_13, "Referral Name")),
                    (_ctx.hasData)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_14, [
                          _createVNode(_component_SortableTh, {
                            "sort-by": _ctx.sortBy,
                            onSortByUpdated: _ctx.sortByUpdated,
                            "sort-order": _ctx.sortOrder,
                            onSortOrderUpdated: _ctx.sortOrderUpdated,
                            "sort-string": "lastName"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_15
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                        ]))
                      : (_openBlock(), _createElementBlock("th", _hoisted_16, "Patient Information")),
                    (_ctx.hasData)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_17, [
                          _createVNode(_component_SortableTh, {
                            "sort-by": _ctx.sortBy,
                            onSortByUpdated: _ctx.sortByUpdated,
                            "sort-order": _ctx.sortOrder,
                            onSortOrderUpdated: _ctx.sortOrderUpdated,
                            "sort-string": "branchName"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_18
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                        ]))
                      : (_openBlock(), _createElementBlock("th", _hoisted_19, "Branch")),
                    (_ctx.hasData)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_20, [
                          _createVNode(_component_SortableTh, {
                            "sort-by": _ctx.sortBy,
                            onSortByUpdated: _ctx.sortByUpdated,
                            "sort-order": _ctx.sortOrder,
                            onSortOrderUpdated: _ctx.sortOrderUpdated,
                            "sort-string": "lineOfService"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_21
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                        ]))
                      : (_openBlock(), _createElementBlock("th", _hoisted_22, "Line of Service")),
                    (_ctx.hasData)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_23, [
                          _createVNode(_component_SortableTh, {
                            "sort-by": _ctx.sortBy,
                            onSortByUpdated: _ctx.sortByUpdated,
                            "sort-order": _ctx.sortOrder,
                            onSortOrderUpdated: _ctx.sortOrderUpdated,
                            "sort-string": "referralSource"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_24
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                        ]))
                      : (_openBlock(), _createElementBlock("th", _hoisted_25, "Referral Type")),
                    (_ctx.hasData)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_26, [
                          _createVNode(_component_SortableTh, {
                            "sort-by": _ctx.sortBy,
                            onSortByUpdated: _ctx.sortByUpdated,
                            "sort-order": _ctx.sortOrder,
                            onSortOrderUpdated: _ctx.sortOrderUpdated,
                            "sort-string": "dateOfBirth"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_27
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                        ]))
                      : (_openBlock(), _createElementBlock("th", _hoisted_28, "Date of Birth")),
                    (_ctx.hasData)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_29, [
                          _createVNode(_component_SortableTh, {
                            "sort-by": _ctx.sortBy,
                            onSortByUpdated: _ctx.sortByUpdated,
                            "sort-order": _ctx.sortOrder,
                            onSortOrderUpdated: _ctx.sortOrderUpdated,
                            "sort-string": "gender"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_30
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                        ]))
                      : (_openBlock(), _createElementBlock("th", _hoisted_31, "Sex")),
                    (_ctx.hasData)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_32, [
                          _createVNode(_component_SortableTh, {
                            "sort-by": _ctx.sortBy,
                            onSortByUpdated: _ctx.sortByUpdated,
                            "sort-order": _ctx.sortOrder,
                            onSortOrderUpdated: _ctx.sortOrderUpdated,
                            "sort-string": "createdBy"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_33
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                        ]))
                      : (_openBlock(), _createElementBlock("th", _hoisted_34, "Created By")),
                    (_ctx.hasData)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_35, [
                          _createVNode(_component_SortableTh, {
                            "sort-by": _ctx.sortBy,
                            onSortByUpdated: _ctx.sortByUpdated,
                            "sort-order": _ctx.sortOrder,
                            onSortOrderUpdated: _ctx.sortOrderUpdated,
                            "sort-string": "liaison"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_36
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                        ]))
                      : (_openBlock(), _createElementBlock("th", _hoisted_37, "Liaison")),
                    (_ctx.hasData)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_38, [
                          _createVNode(_component_SortableTh, {
                            "sort-by": _ctx.sortBy,
                            onSortByUpdated: _ctx.sortByUpdated,
                            "sort-order": _ctx.sortOrder,
                            onSortOrderUpdated: _ctx.sortOrderUpdated,
                            "sort-string": "tags"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_39
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                        ]))
                      : (_openBlock(), _createElementBlock("th", _hoisted_40, "Tags")),
                    _hoisted_41
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (!_ctx.isLoading && !_ctx.isError && !_ctx.hasData && !_ctx.branchRef?.isRequestPending)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_42, [
                        _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_45, 8 /* PROPS */, _hoisted_43)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.isLoading || _ctx.branchRef?.isRequestPending)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.loadingCount, (i) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          class: "table-loading",
                          key: `count-${i}`
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (i) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: `column-${i}`
                            }, _hoisted_47))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  (!_ctx.isLoading && _ctx.isError && !_ctx.branchRef?.isRequestPending)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_48, [
                        _createElementVNode("td", { colspan: _ctx.columns }, [
                          _createVNode(_component_ErrorMessageHandler, {
                            title: "Referral list",
                            "show-try-again": true,
                            "try-again": _ctx.search()
                          }, null, 8 /* PROPS */, ["try-again"])
                        ], 8 /* PROPS */, _hoisted_49)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                (!_ctx.isLoading && !_ctx.isError && _ctx.hasData && !_ctx.branchRef?.isRequestPending)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.page.items, (item) => {
                      return (_openBlock(), _createElementBlock("tbody", {
                        key: item.id
                      }, [
                        _createVNode(_component_CentralReferralRow, {
                          "referrals-editable": _ctx.referralsEditable,
                          "referrals-deleteable": _ctx.referralsDeleteable,
                          referral: item,
                          "non-admit-reasons-data": _ctx.nonAdmitReasonsData,
                          columns: _ctx.columns,
                          branches: _ctx.branches,
                          "line-of-service-enum-map": _ctx.lineOfServiceEnumMap,
                          "get-gender-types": _ctx.getGenderTypes,
                          "reset-list": _ctx.resetList,
                          "refresh-list": _ctx.pageRefresh,
                          "update-non-admit-reasons-data": _ctx.updateNonAdmitReasonsData,
                          dynamicTableToggled: _ctx.dynamicTableToggled,
                          "onUpdate:dynamicTableToggled": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dynamicTableToggled) = $event))
                        }, null, 8 /* PROPS */, ["referrals-editable", "referrals-deleteable", "referral", "non-admit-reasons-data", "columns", "branches", "line-of-service-enum-map", "get-gender-types", "reset-list", "refresh-list", "update-non-admit-reasons-data", "dynamicTableToggled"])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["isLoading", "tableColumnSettings", "columnsAltered", "columns"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["pageChanged", "isLoading", "pageSize", "onUpdatePageSizeChanged"])
    ]),
    _: 1 /* STABLE */
  }))
}